import { render } from "./PublicProjectCard.vue?vue&type=template&id=6116f040&scoped=true"
import script from "./PublicProjectCard.vue?vue&type=script&lang=js"
export * from "./PublicProjectCard.vue?vue&type=script&lang=js"

import "./PublicProjectCard.vue?vue&type=style&index=0&id=6116f040&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6116f040"]])

export default __exports__